import { useState } from "react";
import { Button } from "reactstrap";
import {
  faFileEdit,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';

//Components
import ModalCustomized from "../../../../components/Modal/Modal";
import TextField from "../../../../components/TextField";


function AlteracaoEmail({ onSubmitAlteracaoEmail, infracaoAlteracaoEmail, setInfracaoAlteracaoEmail }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const toggleModal = () => setIsOpenModal(!isOpenModal);
  //Cabeçalhos que a tabela terá

  const campos = [
    objCampo({ name: "emailAtualizado", required: true })
  ];
  const [errors, setErrors] = useState({});
  const onChange = (e) => {
    const { name, value } = e.target;
    const _infracaoAlteracaoEmail = {
      ...infracaoAlteracaoEmail,
      [name]: value
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === name);
    const fieldError = validarCampos(_infracaoAlteracaoEmail, _campos);

    const _errors = { ...errors };
    delete _errors[name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setInfracaoAlteracaoEmail(_infracaoAlteracaoEmail);
  }

  return (
    <>
      <ModalCustomized
        toggle={toggleModal}
        isOpen={isOpenModal}
        btnClose={toggleModal}
        title={"Alteração de e-mail"}
      >

        <TextField
          name={"emailAnterior"}
          label={"* E-mail Anterior"}
          type={"text"}
          value={infracaoAlteracaoEmail.emailAnterior}
          disabled={true}
        />

        <TextField
          name={"emailAtualizado"}
          label={"* E-mail "}
          type={"text"}
          value={infracaoAlteracaoEmail.emailAtualizado}
          onChange={onChange}
          maxLength={100}
          invalid={errors.emailAtualizado}
        />
        <div
          className="d-flex align-items-center justify-content-center"
        >
          <Button onClick={() => {
            toggleModal();
            onSubmitAlteracaoEmail()
          }} color="warning" className='ms-4 text-white'>
            <FontAwesomeIcon icon={faFileEdit} /> Salvar
          </Button>
        </div>
      </ModalCustomized>
      <div className="noPrint">
        <Button
          color="dark"
          className="text-white p-1 m-0 "
          style={{ fontSize: "12px" }}
          onClick={() => toggleModal()}
          role="button"
        >
          <FontAwesomeIcon icon={faFileEdit} /> Alterar e-mail
        </Button>
      </div>
    </>
  );
}

export default AlteracaoEmail;
